import { GET_ADDCAR_REQUESTED, GET_CAR_REQUESTED, GET_DELETECAR_REQUESTED, GET_FACILITIES_REQUESTED, GET_UPDATECAR_REQUESTED } from "resources/actionTypes";

export function getCar(id) {
  const data ={
    id:id,
  }
  return {
    type: GET_CAR_REQUESTED,
    payload:data
  };
}

export function postAddCar(userAddCar) {
  const data ={
    userAddCar:userAddCar,
  }
  return {
    type: GET_ADDCAR_REQUESTED,
    payload: data,
  };
}

export function patchUpdateCar(userUpdateCar) {
  const data ={
    userUpdateCar:userUpdateCar,
  }
  return {
    type: GET_UPDATECAR_REQUESTED,
    payload: data,
  };
}

export function deleteCar(userDeleteCar) {
  const data ={
    userDeleteCar:userDeleteCar,
  }
  return {
    type: GET_DELETECAR_REQUESTED,
    payload: data,
  };
}

export function getFacilities(id) {
  const data ={
    id:id,
  }
  return {
    type: GET_FACILITIES_REQUESTED,
    payload:data
  };
}
